import { Box, Paper, Typography, Checkbox, Avatar, Divider, Grid} from '@mui/material';

const avatarColors = ["#004225", "#800020", "#006D77", "#FF6F00"];

const DetailCard = ({ id, title, subtitleList = [], onEdit, selected, onSelect, avatarText, backgroundColor,}) => {
    const avatarColor = avatarColors[id % avatarColors.length];
    const showSubtitles = subtitleList.length > 0;

    // If no title and no subtitles, treat it as empty
    const isEmpty = !title && subtitleList.length === 0;

    if (isEmpty) {
        return (
            <Paper sx={{ p: 2, borderRadius: 4, bgcolor: '#fef2f2', boxShadow: 1 }}>
                <Typography variant="body1" align="center" color="error">
                    No data found.
                </Typography>
            </Paper>
        );
    }
    
    return (
        <Paper sx={{ p: 2, bgcolor: backgroundColor, display: "flex", flexDirection: "column", borderRadius: 4, boxShadow: 5, }} >
            {/* Header Row */}
            <Box display="flex" alignItems="center" gap={1}>
                {onSelect && ( <Checkbox checked={selected} onChange={() => onSelect(id)} /> )}
                <Avatar
                    sx={{
                        bgcolor: avatarColor,
                        width: 35,
                        height: 35,
                        fontWeight: 600,
                        fontSize: "1rem",
                    }}
                >
                    {avatarText?.toUpperCase() || title?.[0]?.toUpperCase()}
                </Avatar>
                <Typography variant="body1" sx={{ cursor: onEdit ? "pointer" : "default" }} onClick={() => onEdit?.(id)} >
                    {title}
                </Typography>
            </Box>

            {/* Divider (only if subtitleList exists) */}
            {showSubtitles && ( <Divider sx={{ my: 1, ml: onSelect ? 7 : 6 }} /> )}

            {/* Subtitle Content in 2 Columns */}
            {showSubtitles && (
                <Box mt={0} ml={onSelect ? 7 : 6}>
                    <Grid container spacing={1}>
                        {subtitleList.map((text, index) => (
                            <Grid item xs={12} sm={6} key={index}>
                                <Typography variant="body2">{text}</Typography>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
        </Paper>
    );
};

export default DetailCard;